import React from 'react';

interface DaySelectorProps {
  selectedDay: 1 | 2;
  onDayChange: (day: 1 | 2) => void;
}

const DaySelector: React.FC<DaySelectorProps> = ({ selectedDay, onDayChange }) => {
  return (
    <div
      style={{
        display: 'flex',
        gap: '8px',
        padding: '6px',
        background: 'var(--color-surface, #262626)',
        borderRadius: '8px',
        border: '1px solid var(--color-border, #374151)',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
      }}
    >
      {[1, 2].map((day) => (
        <button
          key={day}
          onClick={() => onDayChange(day as 1 | 2)}
          style={{
            padding: '10px 28px',
            fontFamily: 'Orbitron, sans-serif',
            fontSize: '15px',
            fontWeight: 700,
            color: selectedDay === day 
              ? 'var(--color-text, #f3f4f6)' 
              : 'var(--color-text-muted, #a8a29e)',
            background: selectedDay === day
              ? 'linear-gradient(135deg, var(--color-primary, #dc2626) 0%, var(--color-primary-dark, #991b1b) 100%)'
              : 'transparent',
            border: selectedDay === day 
              ? '1px solid var(--color-primary, #dc2626)'
              : '1px solid transparent',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            boxShadow: selectedDay === day
              ? '0 4px 20px rgba(var(--color-primary-rgb, 220, 38, 38), 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.2)'
              : 'none',
            textTransform: 'uppercase',
            letterSpacing: '1px',
          }}
          onMouseEnter={(e) => {
            if (selectedDay !== day) {
              e.currentTarget.style.background = 'rgba(var(--color-primary-rgb, 220, 38, 38), 0.15)';
              e.currentTarget.style.color = 'var(--color-primary, #dc2626)';
              e.currentTarget.style.border = '1px solid rgba(var(--color-primary-rgb, 220, 38, 38), 0.3)';
              e.currentTarget.style.transform = 'scale(1.05)';
            }
          }}
          onMouseLeave={(e) => {
            if (selectedDay !== day) {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.color = 'var(--color-text-muted, #a8a29e)';
              e.currentTarget.style.border = '1px solid transparent';
              e.currentTarget.style.transform = 'scale(1)';
            }
          }}
        >
          Day {day}
        </button>
      ))}
    </div>
  );
};

export default DaySelector;